import React from 'react';
import { dompurifier } from '@nile/components/src/Utils/helpers';

function HtmlParser(props) {
  const sanitizedHtml = dompurifier(props.htmlParser);
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: sanitizedHtml
      }}
    />
  );
}

export default HtmlParser;
